// Caché compartido de las colecciones que usan Home y SearchBar.
// Sin esto, cada uno bajaba las 9 colecciones completas por su cuenta (y en serie):
// 18 descargas secuenciales al abrir la app. Acá se bajan una sola vez, en paralelo,
// y ambos consumen el mismo resultado.
import { db } from './firebase';
import { collection, getDocs } from 'firebase/firestore';

export const COLECCIONES_GLOBALES = [
  'stock', 'clientes', 'compras', 'ventas', 'inventario',
  'viticultura', 'vinificacion', 'embotellado', 'trazabilidad',
];

let cachePromise = null;

// Devuelve todos los docs de las colecciones globales, como array plano
// [{ id, coleccion, ...data }]. La promesa se memoiza: llamadas concurrentes
// o posteriores reusan la misma descarga durante toda la sesión.
export function fetchColeccionesGlobales() {
  if (!cachePromise) {
    cachePromise = Promise.all(
      COLECCIONES_GLOBALES.map(async (col) => {
        const snapshot = await getDocs(collection(db, col));
        return snapshot.docs
          // Vinos demo (DEMO-SHOP-*/DEMO-CUPO-*) creados para probar
          // Shop/Cupo asignado en fincalosastros — solo existen en
          // "stock", pero el filtro por id es inofensivo en el resto.
          .filter((doc) => !doc.id.startsWith('DEMO-'))
          .map((doc) => ({
            id: doc.id,
            coleccion: col,
            ...doc.data(),
          }));
      })
    )
      .then((porColeccion) => porColeccion.flat())
      .catch((err) => {
        // No memoizar errores: el próximo llamado reintenta.
        cachePromise = null;
        throw err;
      });
  }
  return cachePromise;
}

// Llamar después de crear/editar datos (ventas, compras, trazabilidad, etc.)
// para que la próxima visita a Home/SearchBar baje datos frescos.
export function invalidarCacheColecciones() {
  cachePromise = null;
}
